export const useUserInfo = () => {
  const userInfo = {
    favoriteLimit: 5,
  }

  return { userInfo }
}
